import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import '@yy/tofu-ui-react/dist/index.css';
import 'normalize.css';
import './style/index.scss';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
